import React, { FunctionComponent } from 'react'
import * as S from './styled'
import { ReactComponent as SearchIcon } from '../../atoms/Icons/SearchIcon.svg'
type OwnProps = {
  setSearch: React.Dispatch<React.SetStateAction<string>>
}

type Props = OwnProps

const SearchBar: FunctionComponent<Props> = ({ setSearch }) => {
  return (
    <S.Container>
      <S.InputWrapper>
        <SearchIcon />
        <S.Input type="text" placeholder="Sök..." onChange={e => setSearch(e.target.value)} />
      </S.InputWrapper>
    </S.Container>
  )
}

export default SearchBar
